import i18n from "i18n";

export const getOffers = () => [
  // {
  //   name: i18n.t("careerSection.jobs.customerService"),
  //   city: "KATOWICE",
  //   link: "https://www.olx.pl/oferta/praca/host-obsluga-klienta-pixel-xl-CID4-ID10gxsA.html",
  // },
];
